import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgCommonModule } from '@principle-theorem/ng-shared';

@Component({
  selector: 'pr-custom-report-scopes',
  templateUrl: './custom-report-scopes.component.html',
  styleUrls: ['./custom-report-scopes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'inline-block',
  },
  imports: [NgCommonModule],
})
export class CustomReportScopesComponent {
  scopes = input.required<string[]>();
  highlightScope = input<string | undefined>();
}
